// extracted by mini-css-extract-plugin
module.exports = {"main":"_500ccc21 mb2 w-100 ph3","button":"b389fb86","text":"a3795982","linkText":"_5b35c399"};